import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { AccountService } from "../services/account.service";
import { HomePageComponent } from "./home-page/home-page.component";
import { map } from "rxjs";

@Injectable()
export class UnauthenticatedGuard implements CanActivate {
    public constructor(
        private accountService: AccountService,
        private router: Router,
    ) { }

    public canActivate() {
        return this.accountService.isLoggedIn$.pipe(
            map((isLoggedIn) => !isLoggedIn || this.router.parseUrl(HomePageComponent.Path)),
        );
    }
}
